<template>
    <div class="bar">
        <div class="result">
            <div>为您匹配出 <span class="num">{{ count }}</span> 条产品</div>
        </div>
        <div class="sort">
            <div v-for="item in sorts" :key="item.value" class="sort-item"
                :class="{ active: currentSort.indexOf(item.value) !== -1 }" @click="onChange(item)">
                <router-link v-if="!item.options" v-slot="{ href }" replace
                    :to="{ path: $route.path, query: { ...$route.query, sort_name: item.value, sort_type: '', page_index: 1 } }"
                    custom><a :href="href" target="_self">{{ item.label }}</a></router-link>
                <span v-else>{{ renderCurrentLable(item) }}</span>
                <template v-if="item.options && item.options.length">
                    <i class="el-icon-caret-bottom arrow ml-1"></i>
                    <ul class="sort-ul">
                        <li v-for="op in item.options" :key="op.value"
                            :class="{ active: currentSortType == op.value && currentSort.indexOf(item.value) !== -1 }"
                            @click="onChange(item, op)">
                            <router-link v-slot="{ href }" replace
                                :to="{ path: $route.path, query: { ...$route.query, sort_name: item.value, sort_type: op.value, page_index: 1 } }"
                                custom><a :href="href" target="_self">{{ op.label }}</a></router-link>
                        </li>
                    </ul>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sorts: {
            type: Array,
            default: () => ([{
                label: '综合排序',
                value: '1',
            }, {
                label: '出发日期',
                value: '5',
                options: [
                    {
                        label: '日期 近 -> 远',
                        value: '4'
                    },
                    {
                        label: '日期 远 -> 近',
                        value: '3'
                    }
                ]
            },
            {
                label: '出游天数',
                value: '7',
                options: [
                    {
                        label: '天数 少 -> 多',
                        value: '4'
                    },
                    {
                        label: '天数 多 -> 少',
                        value: '3'
                    }
                ]
            },
            {
                label: '产品价格',
                value: '2',
                options: [
                    {
                        label: '价格 低 -> 高',
                        value: '4'
                    },
                    {
                        label: '价格 高 -> 低',
                        value: '3'
                    }
                ]
            }])
        },
        count: {
            type: Number,
            default: 0
        },
        initSort: {
            type: Array,
            default: () => []
        },
        initSortType: {
            type: String,
            default: ''
        },
        selectType: {
            validator(value) {
                return ['single', 'multiple'].includes(value);
            },
            default: 'single'
        }
    },
    data() {
        return {
            currentSort: [],
            currentSortType: ''
        };
    },
    methods: {
        onChange(item, op) {
            if (item.options && item.options.length && !op)
                return;
            let index = this.currentSort.indexOf(item.value);
            if (this.selectType === 'multiple') {
                if (index === -1) {
                    this.currentSort.push(item.value);
                }
                else {
                    this.currentSort.splice(index, 1);
                }
                this.$emit('onChange', this.currentSort, '4'); // 3倒序；4正序
            }
            else {
                if (index === -1 || (op && op.value !== this.currentSortType)) {
                    this.currentSort = [item.value];
                    this.currentSortType = op ? op.value : '';
                    this.$emit('onChange', this.currentSort[0], this.currentSortType) // 3倒序；4正序
                }
            }
        },
        renderCurrentLable(sortItem) {
            let index = this.currentSort.indexOf(sortItem.value);
            if (index === -1 || !this.currentSortType) {
                return sortItem.label;
            }
            return sortItem.options.find(op => op.value === this.currentSortType).label;
        },
    },
    mounted() {
        this.currentSort = this.initSort;
        this.currentSortType = this.initSortType;
    },
}
</script>

<style lang="scss" scoped>
.bar {
  height: 60px;
  width: 100%;
  background: #F3F5F8;
  position: relative;
  padding: 0 28px 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bar .result {
  font-size: 20px;
  color: #3D3D3D;
}
.bar .result .num {
  --tw-text-opacity: 1;
  color: rgba(22, 53, 144, var(--tw-text-opacity));
}
.bar .sort {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #3D3D3D;
  margin-right: -12px;
  height: 100%;
}
.bar .sort-item {
  padding: 0 12px;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.bar .sort-item .arrow {
  transition: all 0.2s ease-out;
}
.bar .sort-item .sort-ul {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  position: absolute;
  left: 0px;
  top: 100%;
  z-index: 10;
  display: none;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.bar .sort-item .sort-ul li {
  font-size: 16px;
  color: #3D3D3D;
  margin-bottom: 8px;
  white-space: nowrap;
  cursor: pointer;
}
.bar .sort-item .sort-ul li:hover {
  --tw-text-opacity: 1;
  color: rgba(22, 53, 144, var(--tw-text-opacity));
}
.bar .sort-item .sort-ul li:last-child {
  margin-bottom: 0;
}
.bar .sort-item .sort-ul li.active {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.bar .sort-item:after {
  position: absolute;
  content: '';
  height: 20px;
  border-left: 1px solid #c8c8c8;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.bar .sort-item:nth-last-child(1):after {
  display: none;
}
.bar .sort-item:hover {
  --tw-text-opacity: 1;
  color: rgba(22, 53, 144, var(--tw-text-opacity));
}
.bar .sort-item:hover .sort-ul {
  display: block;
}
.bar .sort-item:hover .arrow {
  border-top-color: $highlight-color;
  transform: rotate(180deg);
}
.bar .sort .active {
  --tw-text-opacity: 1;
  color: rgba(22, 53, 144, var(--tw-text-opacity));
}
.bar .sort .active>span {
  font-weight: 500;
}
.bar .sort .active .triangle-down {
  border-top-color: $highlight-color;
}
</style>
